import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button } from "primereact/button"
import { Menu as PrimereactMenu } from "primereact/menu"
import React, { useRef } from "react"
import "./styles.scss"

const Menu = ({
  items,
  className = "",
  popupAlignment = "left",
}: $TSMigrationFixMe) => {
  const menu = useRef(null)

  return (
    <>
      <PrimereactMenu
        model={items}
        popup
        ref={menu}
        id='popup_menu'
        // @ts-expect-error TS(2769): No overload matches this call.
        popupAlignment={popupAlignment}
        show
        className={className}
      />
      <Button
        className='tw-flex tw-justify-center tw-items-center tw-cursor-pointer tw-h-10 !tw-w-10 tw-rounded-md !tw-bg-transparent tw-border-transparent hover:!tw-border-transparent'
        icon={
          <FontAwesomeIcon
            icon={["fal", "ellipsis-v"]}
            aria-controls='popup_menu'
            aria-haspopup
            className='tw-text-black tw-w-full tw-h-full'
          />
        }
        // @ts-expect-error TS(2531): Object is possibly 'null'.
        onClick={(event) => menu.current?.toggle(event)}
        aria-controls='popup_menu'
        aria-haspopup
      />
    </>
  )
}

export default React.forwardRef(Menu)
